const html = document.documentElement;
const body = document.body;

export {
    html,
    body
};



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/utilities/dom-elements/javascript/dom-elements/dom-elements.js